/*
 * @Description:
 * @Author: fal
 * @Date: 2025-08-25 15:26:50
 * @FilePath: \xhlz_pc\src\router\admin.js
 * @LastEditTime: 2025-11-04 14:48:49
 */
export const adminRoutes = [
  // 控制面板
  {
    path: '/admin/dashboard',
    name: 'adminDashboard',
    component: () => import('@/views/brife/brife.vue'),
    meta: {
      title: '首页/数据统计',
      componentName: 'brife',
      keepAlive: true,
    },
  },
  {
    path: '/admin/platform',
    name: 'adminPlatform',
    component: () => import('@/views/brife/brife.vue'),
    meta: {
      title: '平台信息',
      componentName: 'platform',
      keepAlive: true,
    },
  },
  {
    path: '/admin/agreement',
    name: 'adminAgreement',
    component: () => import('@/views/agreement/index.vue'),
    meta: {
      title: '协议管理',
      componentName: 'agreementIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/advertisement',
    name: 'adminAdvertisement',
    component: () => import('@/views/ad/index.vue'),
    meta: {
      title: '广告管理',
      componentName: 'adIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/news',
    name: 'adminNews',
    component: () => import('@/views/news/index.vue'),
    meta: {
      title: '新闻与公告管理',
      componentName: 'newsIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/demand/recruit',
    name: 'adminRecruit',
    component: () => import('@/views/demand/recruit.vue'),
    meta: {
      title: '招聘信息',
      componentName: 'recruitDemand',
      keepAlive: true,
    },
  },
  {
    path: '/admin/demand/labor',
    name: 'adminLabor',
    component: () => import('@/views/demand/laborDemand.vue'),
    meta: {
      title: '工程劳务采购',
      componentName: 'laborDemand',
      keepAlive: true,
    },
  },
  {
    path: '/admin/demand/material',
    name: 'adminMaterial',
    component: () => import('@/views/demand/material.vue'),
    meta: {
      title: '材料设备采购信息',
      componentName: 'materialDemand',
      keepAlive: true,
    },
  },
  {
    path: '/admin/demand/machinery',
    name: 'adminMachinery',
    component: () => import('@/views/demand/machinery.vue'),
    meta: {
      title: '机械采购信息',
      componentName: 'machineryDemand',
      keepAlive: true,
    },
  },
  {
    path: '/admin/demand/consultation',
    name: 'adminConsultation',
    component: () => import('@/views/demand/consultation.vue'),
    meta: {
      title: '业务咨询',
      componentName: 'consultationDemand',
      keepAlive: true,
    },
  },
  {
    path: '/admin/supply/manage',
    name: 'adminGoods',
    component: () => import('@/views/supply/goods.vue'),
    meta: {
      title: '商品管理',
      componentName: 'goodsIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/supply/jobs',
    name: 'adminJobs',
    component: () => import('@/views/supply/jobs.vue'),
    meta: {
      title: '求职信息',
      componentName: 'jobsIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/supply/laborsupply',
    name: 'adminLaborsupply',
    component: () => import('@/views/supply/laborsupply.vue'),
    meta: {
      title: '工程劳务供应',
      componentName: 'laborsupplyIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/quotation',
    name: 'adminQuotation',
    component: () => import('@/views/quotation/index.vue'),
    meta: {
      title: '报价审核',
      componentName: 'quotationIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/invite',
    name: 'adminInvite',
    component: () => import('@/views/invite/index.vue'),
    meta: {
      title: '邀请码代理',
      componentName: 'inviteIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/equipment',
    name: 'adminEquipment',
    component: () => import('@/views/brife/brife.vue'),
    meta: {
      title: '设备管理',
      componentName: 'equipmentIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/project',
    name: 'adminProject',
    component: () => import('@/views/project/index.vue'),
    meta: {
      title: '项目管理',
      componentName: 'projectIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/company/material',
    name: 'adminCompanyMaterial',
    component: () => import('@/views/company/index.vue'),
    meta: {
      title: '材料公司',
      componentName: 'materialCompany',
      keepAlive: true,
    },
  },
  {
    path: '/admin/company/machinery',
    name: 'adminCompanyMachinery',
    component: () => import('@/views/company/index.vue'),
    meta: {
      title: '机械公司',
      componentName: 'machineryCompany',
      keepAlive: true,
    },
  },
  {
    path: '/admin/company/construction',
    name: 'adminConstruction',
    component: () => import('@/views/company/index.vue'),
    meta: {
      title: '施工单位',
      componentName: 'constructionCompany',
      keepAlive: true,
    },
  },
  {
    path: '/admin/company/other',
    name: 'adminOther',
    component: () => import('@/views/company/index.vue'),
    meta: {
      title: '其他公司',
      componentName: 'otherCompany',
      keepAlive: true,
    },
  },
  {
    path: '/admin/account',
    name: 'adminAccount',
    component: () => import('@/views/account/index.vue'),
    meta: {
      title: '账号管理',
      componentName: 'accountIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/push',
    name: 'adminPush',
    component: () => import('@/views/push/index.vue'),
    meta: {
      title: '平台推送',
      componentName: 'pushIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/permission',
    name: 'adminPermission',
    component: () => import('@/views/permission/index.vue'),
    meta: {
      title: '平台账号',
      componentName: 'permissionIndex',
      keepAlive: true,
    },
  },
  {
    path: '/admin/serverManage',
    name: 'adminServerManage',
    component: () => import('@/views/server/index.vue'),
    meta: {
      title: '服务器管理',
      componentName: 'adIndex',
      keepAlive: true,
    },
  },
];
